var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',[_vm._v("Add Card")]),_c('v-card-text',[_c('stripe-element',{attrs:{"button-text":"add card","public-key":_vm.publicKey,"intent-id":_vm.intentId,"add-card":true,"client-secret":_vm.clientSecret},on:{"payment-success":_vm.paymentSuccess,"payment-failed":_vm.paymentFailed}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }